<template>
	<div id="app">
		<!-- <img alt="Vue logo" src="./assets/logo.png"> -->
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app',
		created() {
			// 注册全局前置守卫，即在路由切换前执行
			this.$router.beforeEach((to, from, next) => {
				// 根据路由的路径动态修改 body 样式
				// console.log(to);
				if (to.path === '/appDownInfo') {
					document.body.style.background = '#fff';
				} else{
					document.body.style.background = '#F7F8FA';
				}
				next(); // 继续路由导航
			})
		},
		components: {

		}
	}
</script>

<style>
	* {
		margin: 0;
	}

	#app {
		/* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50; */
		/* margin-top: 60px; */
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
	}

	img {
		display: block;
	}

	.txt-act:hover {
		opacity: 0.8;
		cursor: pointer;
	}

	.fl-col {
		display: flex;
		flex-direction: column;
	}

	.fl-al {
		display: flex;
		align-items: center;
	}

	.fl-center-al {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.fl-bas {
		display: flex;
		align-items: baseline;
	}

	.fl-between-al {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.fl-center-col {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.two-line {
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		/* //溢出内容隐藏 */
		text-overflow: ellipsis;
		/* //文本溢出部分用省略号表示 */
		display: -webkit-box;
		/* //特别显示模式 */
		line-clamp: 2;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.three-line {
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		/* //溢出内容隐藏 */
		text-overflow: ellipsis;
		/* //文本溢出部分用省略号表示 */
		display: -webkit-box;
		/* //特别显示模式 */
		line-clamp: 3;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}

	.one-line {
		overflow: hidden;
		/* // 溢出隐藏 */
		white-space: nowrap;
		/* // 强制一行 */
		text-overflow: ellipsis;
	}

	.all-bottom-btn {
		width: 622rpx;
		height: 84rpx;
		background: linear-gradient( 138deg, #1FED83 0%, #19C76C 100%);
		border-radius: 52px 52px 52px 52px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 auto;
		font-size: 32rpx;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		cursor: pointer;
	}
</style>